import { Api } from 'utils';

class JobApplicationService {

	static create = async (params?: any) => Api.createResponse('job-applications/create',params);
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/job-applications',params),
	}

}

export default JobApplicationService;